<template>
  <div class="page">
    <div class="container text-center">
      <h1 class="mt-4">Security</h1>
    </div>

    <div class="container mt-4">
      <div class="card">
        <div class="card-header">
          <h3>Recent security activity</h3>
        </div>
        <div class="card-body">
          <div v-for="(active, i) in activities" :key="i" class="row line">
            <div class="col-4">{{ active.viewer.platform.name }} <span class="note" v-if="active.token == auth.token">(You)</span></div>
            <div class="col-7 text-secondary">{{ this.$filters.timeago(active.createdAt) }}</div>
            <div class="col-1">
              <button class="btn btn-sm" v-if="active.token !== auth.token" @click="onDetailActivity(active, i)">
                <i class="fa-solid fa-angle-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-4">
      <div class="card">
        <div class="card-header">
          <h3>Security & methods</h3>
        </div>
        <div class="card-body">
          <div class="row line" v-if="methods.password">
            <div class="col-4"><i class="fa-regular fa-keyboard"></i> Change password</div>
            <div class="col-7 text-secondary">Last change {{this.$filters.timeago(methods.password.lastChange, 'Not yet')}}</div>
            <div class="col-1">
              <button class="btn btn-sm" @click="openChangePassword()">
                <i class="fa-solid fa-angle-right"></i>
              </button>
            </div>
          </div>

          <div class="row line" v-if="methods.twoFactor">
            <div class="col-4"><i class="fa-solid fa-qrcode"></i> Authenticator</div>
            <div class="col-7 text-secondary">{{ methods.twoFactor.enabled ? 'On' : 'Off' }}</div>
            <div class="col-1">
              <button class="btn btn-sm" @click="handleTwoFactor()">
                <i class="fa-solid fa-angle-right"></i>
              </button>
            </div>
          </div>

          <div class="row line" v-if="methods.email">
            <div class="col-4"><i class="fa-regular fa-envelope"></i> Recovery email</div>
            <div class="col-7 text-secondary">Unset</div>
            <div class="col-1">
              <button class="btn btn-sm">
                <i class="fa-solid fa-angle-right"></i>
              </button>
            </div>
          </div>

          <div class="row line" v-if="methods.phone">
            <div class="col-4"><i class="fa-solid fa-tty"></i> Recovery phone</div>
            <div class="col-7 text-secondary">Unset</div>
            <div class="col-1">
              <button class="btn btn-sm">
                <i class="fa-solid fa-angle-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Change password modal -->
  <b-modal ref="changePassword">
    <div class="modal-header">
      <h5 class="modal-title">Change password</h5>
    </div>
    <div class="modal-body">
      <form autocomplete="off" onsubmit="event.preventDefault();">
        <div>
          <label>Current password:</label>
          <input type="password" class="form-control" v-model="changePasswordForm.currentPassword"
            placeholder="Current password" :class="{ 'border-danger': changePasswordForm.errors.currentPassword }">
          <div class="msg-error" v-if="changePasswordForm.errors.currentPassword">{{
            changePasswordForm.errors.currentPassword }}</div>
        </div>

        <div class="mt-3">
          <label>New password:</label>
          <input type="password" class="form-control" v-model="changePasswordForm.password" placeholder="New password"
            :class="{ 'border-danger': changePasswordForm.errors.password }">
          <div class="msg-error" v-if="changePasswordForm.errors.password">{{ changePasswordForm.errors.password
          }}</div>
        </div>

        <div class="mt-3">
          <label>Confirm password:</label>
          <input type="password" class="form-control" v-model="changePasswordForm.confirmPassword"
            placeholder="Confirm password" :class="{ 'border-danger': changePasswordForm.errors.confirmPassword }">
          <div class="msg-error" v-if="changePasswordForm.errors.confirmPassword">{{
            changePasswordForm.errors.confirmPassword }}</div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-sm btn-secondary" @click="$refs.changePassword.hide()">
        Cancel
      </button>
      <button type="button" class="btn btn-sm btn-success" @click="onChangePassword()">
        Change
      </button>
    </div>
  </b-modal>

  <!-- Enable two factor -->
  <b-modal ref="twoFactor">
    <div class="modal-header">
      <h5 class="modal-title">Two-factor authentication</h5>
    </div>
    <div class="modal-body">
      <form autocomplete="off" onsubmit="event.preventDefault();">
        <div v-if="twoFactor.qrcode" class="text-center">
          <img :src="twoFactor.qrcode">
        </div>
        <div v-if="twoFactor.secret" class="mt-3 secret">
          <input type="text" class="form-control" v-model="twoFactor.secret" readonly>
        </div>
        <div :class="{'mt-3': twoFactor.secret}">
          <label>Verify code:</label>
          <input type="text" class="form-control" v-model="twoFactor.code"
            placeholder="Authenticator code" :class="{ 'border-danger': twoFactor.errors.code }">
          <div class="msg-error" v-if="twoFactor.errors.code">{{twoFactor.errors.code }}</div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-sm btn-secondary" @click="$refs.twoFactor.hide()">
        Cancel
      </button>
      <button type="button" class="btn btn-sm btn-success" v-if="twoFactor.qrcode" @click="onTwoFactor()">
        Enable
      </button>
      <button type="button" class="btn btn-sm btn-danger" v-else @click="onTwoFactor()">
        Disable
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      activities: [],
      methods: {},
      changePasswordForm: this.getChangePasswordForm(),
      twoFactor: this.getTwoFactorForm()
    }
  },

  computed: {
    auth(){
      return this.$store.state.auth;
    }
  },

  methods: {
    getChangePasswordForm() {
      return {
        isLoading: false,
        errors: {},
        currentPassword: '',
        password: '',
        confirmPassword: ''
      }
    },

    getTwoFactorForm(){
      return {
        secret: '',
        qrcode: '',
        errors: {},
        code: ''
      };
    },

    openChangePassword() {
      this.changePasswordForm = this.getChangePasswordForm();
      this.$refs.changePassword.show();
    },

    async loadActivities() {
      let r = await this.$aloop.account.auth.activities().call();

      if (r.success) {
        this.activities = r.response;
      }
    },

    async loadMethods() {
      let r = await this.$aloop.account.auth.verifyMethods().call();

      if (r.success) {
        this.methods = r.response;
      }
    },

    async onChangePassword() {
      this.changePasswordForm.isLoading = true;
      let res = await this.$aloop.account.auth.changePassword({
        currentPassword: this.changePasswordForm.currentPassword,
        password: this.changePasswordForm.password,
        confirmPassword: this.changePasswordForm.confirmPassword
      }).call();
      this.changePasswordForm.isLoading = false;

      if (res.success) {
        this.methods.password.lastChange = res.response.lastChange;
        this.$refs.changePassword.hide();
        this.$store.dispatch('toast/show', {
          data: {message: 'Change password successfully'},
          variant: 'success',
          delay: 2000
        });
      } else {
        this.changePasswordForm.errors = res.response.errors;
      }
    },

    onDetailActivity(active, index){
      this.$store.dispatch('confirmation/open', {
        title: 'Activity detail',
        type: 'confirmation',
        message: 'Name: ' + active.viewer.platform.name + '<br/>'
                + 'OS: ' + active.viewer.platform.os + '('+active.viewer.platform.version+')' + '<br/>'
                + 'Location: ' + active.viewer.location,
        options: [
          {
            name: 'cancel',
            label: 'Cancel',
            variant: 'secondary'
          },
          {
            name: 'del-session',
            label: 'Delete session',
            variant: 'danger'
          }
        ],
        events: {
          confirm: async (name) => {
            if (name == 'del-session') {
              let r = await this.$aloop.account.auth.deleteActivity({
                token: active.token
              }).call();

              if (r.success) {
                this.activities.splice(index, 1);
                this.$store.dispatch('toast/show', {
                  data: {message: 'Delete session successfully'},
                  variant: 'success',
                  delay: 2000
                });
              }
            }
          }
        }
      });
    },

    async onTwoFactor(){
      let res = await this.$aloop.account.twoFactor.update({
        code: this.twoFactor.code
      }).call();

      if (res.success) {
        this.methods.twoFactor.enabled = res.response.enabled;
        this.$refs.twoFactor.hide();
      }
      else{
        this.twoFactor.errors = res.response.errors;
      }
    },

    handleTwoFactor(){
      let title, message, options;
      title = 'Two factor authenticator';

      // Check if use is active
      if (this.methods.twoFactor.enabled) {
        message = 'You are ready enabled Two-Factor authenticator';
        options = [
          {name: 'close', label: 'Cancel', variant: 'secondary'},
          {name: 'disable', label: 'Disable', variant: 'danger'}
        ];
      } else {
        message = 'Two-Factor authenticator is disabled';
        options = [
          {name: 'close', label: 'Cancel', variant: 'secondary'},
          {name: 'enable', label: 'Enable', variant: 'success'}
        ];
      }

      this.$store.dispatch('confirmation/open', {
        title,
        type: 'confirmation',
        message,
        options,
        events: {
          confirm: async(name) => {
            this.twoFactor = this.getTwoFactorForm();

            if (name == 'disable') {
              this.$refs.twoFactor.show();
            }

            if (name == 'enable') {
              let res = await this.$aloop.account.twoFactor.generate().call();

              if (res.success) {
                this.twoFactor.secret = res.response.secret;
                this.twoFactor.qrcode = res.response.qrcode;
                this.$refs.twoFactor.show();
              }
            }
          }
        }
      });
    }
  },

  mounted() {
    this.loadActivities();
    this.loadMethods();
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding-top: 90px;
  width: 900px;
  max-width: 100%;
  margin: 0 auto;
}

h1 {
  font-size: 1.2rem;
}

h3 {
  font-size: 1.2rem;
}

.unset {
  font-style: italic;
  color: var(--color-body-text-hover);
  font-size: 0.8rem;
}

.note {
  color: var(--color-body-text-hover);
  font-size: 0.8rem;
  margin-left: 10px;
}

.card-body {
  .line {
    &:hover {
      background-color: var(--color-page-menu-bg-hover);

    }

    &:not(:last-child) {
      border-bottom: 1px solid var(--color-top-menu-border);
    }

    >div {
      display: flex;
      align-items: center;
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;

      &:last-child{
        justify-content: end;
      }

      &:first-child {
        i {
          margin-right: 5px;
        }
      }

      >button {
        color: var(--color-body-text);
        font-size: 1.3rem;
        border: 0 !important;

        &:focus,
        &:active {
          outline: 0;
          border: 0 !important;
        }
      }
    }
  }

  >.d-flex {
    >div {
      &:last-child {
        flex: 1;
      }

      &:first-child {
        width: 30%;

        label {
          color: var(--color-body-text-hover);
        }
      }
    }
  }
}

.modal-body form {
  label {
    font-size: 0.8rem;
    margin-bottom: 2px;
  }

  .error {
    font-size: 0.8rem;
  }
}
</style>